<div class="overview">

    <div class="main-header">
        <h1 class="form-title">Add new product</h1>
        <button #cancelIcon class="btn-submit-cancel"  clickable (click)="gotoAccounts()"></button>
    </div>

    <div class="overview-customers">
      <h2 class="">Products, our customers love</h2>
      <p>Providing all Islamic financial solutions to banking sector customers</p>
    </div>

    <div class="product-list">
        <ul>
            <li clickable (click)="openNewAccount('current')">
                <span class="product-icon"><img src="./assets/images/icons/mutual-funds.svg" /></span>
                <span class="product-name">Current<br/>account</span>
            </li>
            <li clickable (click)="openNewAccount('savings')">
                <span class="product-icon"><img src="./assets/images/icons/mutual-funds.svg" /></span>
                <span class="product-name">Savings<br/>account</span>
            </li>
            <li clickable (click)="openNewAccount('deposit')">
              <span class="product-icon"><img src="./assets/images/icons/invest.svg" /></span>
              <span class="product-name">Term<br/>deposit</span>
          </li>
        </ul>
    </div>

</div>
